var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91397 0.665645C1.18941 0.67964 0.574424 1.44926 0.55957 2.02004V27.3021C0.559661 28.0113 1.20481 28.6565 1.91397 28.6565H27.1961C27.9052 28.6565 28.5504 28.0113 28.5505 27.3021V15.5641C28.5604 14.8485 27.9117 14.1955 27.1961 14.1955C26.4805 14.1955 25.8316 14.8485 25.8417 15.5641V25.9477H3.26837V3.37444H22.6814C23.3969 3.38438 24.0499 2.73566 24.0499 2.02004C24.0499 1.30442 23.3969 0.655487 22.6814 0.665645H1.91397ZM30.2999 2.03412C29.9554 2.05173 29.6196 2.20645 29.3829 2.45737C24.6259 7.43443 20.0306 12.7938 15.3592 17.7508L8.68596 11.8677C8.15409 11.3949 7.24001 11.4486 6.76723 11.9805C6.29446 12.5124 6.34823 13.4265 6.8801 13.8993L14.555 20.6713C15.0747 21.128 15.9551 21.0882 16.4314 20.5866C21.4873 15.297 26.3531 9.5408 31.3298 4.33381C32.2431 3.33444 31.423 2.01133 30.2999 2.03412Z",
    fill: "#FB7940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.a65d388047c58f017349b8735488af62.svg";
export { ForwardRef as ReactComponent };